<template>
	<div v-cloak>
		<img src="@/assets/img_home_banner1.png" alt="" class="banner" />
		<img src="@/assets/img_home_banner.png" alt="" class="banner banner_small" />

		<div class="container">
			<div class="content">
				<div class="title"><p>精神疾病人工智能精准数字诊疗云服务</p></div>
				<div class="cloudService">
					<p>
						基于人工智能、5G+、物联网、云计算、大数据、虚拟现实、智能可穿戴设备等软硬件技术支撑，基于脑神经MRI影像数据，目标个体的包括睡眠、心率、运动、语音、表情等日常复杂行为数据，分析人体的心理健康状态，
						实现疾病早期的精准筛查、诊断和个性化精准治疗方案，并提供智能风险评估、高危人群预警提醒、远程数字化诊疗、常态化康复管理等全疾病周期闭环的诊疗和健康管理服务。
					</p>

					<div class="box">
						<div class="" v-for="(item, index) in cloudServiceList">
							<img :src="item.img" alt="" />
							<h5>{{ item.name.split(' ')[0] }}</h5>
							<h5>{{ item.name.split(' ')[1] }}</h5>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container partner">
			<div class="content">
				<div class="title"><p>全球顶级科研伙伴与行业用户</p></div>

				<div class="box">
					<img :src="require(`@/assets/img_logo_${index + 1}.png`)" alt="" v-for="(item, index) in 12" />
					<span></span>
					<span></span>
					<span></span>
				</div>
			</div>
		</div>

		<div class="container">
			<div class="content">
				<div class="title"><p>全球目前已知最大重性精神疾病脑神经影像数据库</p></div>
				<div class="database">
					<p>
						基于目前参与合作的17
						家医院、30余个研究组的数据采集工作，已完成包括精神分裂症、双相障碍和重性抑郁障碍三种重性精神疾病的，目前世界范围内已知最大的多中心重性精神疾病样本库。
					</p>

					<router-link to="/Solution" class="btn">
						了解更多
						<img src="@/assets/icon_liaojie_gengduo.png" alt="" />
					</router-link>

					<!-- PC -->
					<div class="box" v-show="!isApp">
						<div class="">
							<img src="@/assets/icon_yiyuan.png" alt="" />
							<span>17家医院</span>
						</div>
						<div class="">
							<img src="@/assets/icon_yanjiuzu.png" alt="" />
							<span>30余个研究组</span>
						</div>
						<div class="">
							<img src="@/assets/icon_zhongxing_jibing_yanjiu.png" alt="" />
							<span>3个重性疾病研究</span>
						</div>
					</div>

					<!-- 移动 -->
					<div class="box" v-show="isApp">
						<div class="">
							<img src="@/assets/icon_yiyuan.png" alt="" />
							<span>医院</span>
							<span>
								<b>17</b>
								家
							</span>
						</div>
						<div class="">
							<img src="@/assets/icon_yanjiuzu.png" alt="" />
							<span>研究组</span>
							<span>
								<b>30</b>
								余个
							</span>
						</div>
						<div class="">
							<img src="@/assets/icon_zhongxing_jibing_yanjiu.png" alt="" />
							<span>重性疾病研究</span>
							<span>
								<b>2</b>
								个
							</span>
						</div>
					</div>

					<router-link to="/Solution" class="btn btn2">
						了解更多
						<img src="@/assets/icon_liaojie_gengduo.png" alt="" />
					</router-link>
				</div>
			</div>
		</div>

		<div class="container intervention newIntervention">
			<div class="content">
				<div class="textarea">
					<!-- <span>管理解决方案</span> -->
					<h5>全球首个精神疾病无创神经调控治疗医师决策支持系统</h5>
					<p>
						自主专利“极智深脑”人工智能脑影像组学精神疾病精准诊断技术，采用AI技术进行影像学分析，基于脑功能动力学原理，进行rTMS精准神经调控治疗，生成针对个体患者定制化的治疗方案，为临床医师提供远程决策支持服务。
					</p>
					<router-link to="/Solution" class="moreBtn">
						了解更多
						<img src="@/assets/icon_liaojie_gengduo.png" alt="" />
					</router-link>
				</div>
				<!-- <img src="@/assets/img_guanli_jiejue_fangan.png" alt="" class="bg" /> -->
			</div>
		</div>

		<div class="container cloudPlatform">
			<div class="content">
				<img src="@/assets/img_fuwu_yunpingtai.png" alt="" class="bg" />
				<div class="textarea">
					<!-- <span>服务云平台</span> -->
					<h5>精神心理类疾病全病程诊疗服务云平台</h5>
					<p>
						<em class="icon">soulgym</em>
						云平台各功能模块完整覆盖疾病筛查-诊断-干预-康复全疾病周期，公司团队自研
						<em class="icon2">极智深脑</em>
						AI分布式计算引擎：独有深度迭代聚类、神经架构搜索、超大规模图计算等算法，对高维复杂疾病数据进行综合分析，为医院及家庭用户提供完善的精神心理疾病数字化智能化的精准诊疗、管理、康复服务。
					</p>
					<router-link to="/ProductCenter" class="moreBtn">
						了解更多
						<img src="@/assets/icon_liaojie_gengduo.png" alt="" />
					</router-link>
				</div>
				<img src="@/assets/img_fuwu_yunpingtai.png" alt="" class="bg" />
			</div>
		</div>
	</div>
</template>

<script>
import { GlobalMixin } from '@/util/globalMixin';
export default {
	name: 'Index',
	mixins: [GlobalMixin],
	data() {
		return {
			cloudServiceList: [
				{
					img: require('@/assets/icon_naoyingxiang_jingzhun_zhenduan.png'),
					name: '脑影像 精准诊断'
				},
				{
					img: require('@/assets/icon_gexinghua_zhenliao_jiece.png'),
					name: '个性化 诊疗决策'
				},
				{
					img: require('@/assets/icon_ai_jishu_jingzhun_shaicha.png'),
					name: 'AI技术 精准筛查'
				},
				{
					img: require('@/assets/icon_shuzibiaoxing_pinggu.png'),
					name: '数字表型 评估'
				},
				{
					img: require('@/assets/icon_wuchuangshenjing_tiaokong_zhiliao.png'),
					name: '无创神经 调控治疗'
				},
				{
					img: require('@/assets/icon_xuancheng_shuzi_liaofa.png'),
					name: '远程数字 疗法'
				},
				{
					img: require('@/assets/icon_xunixianshi_jiaohuliaofa.png'),
					name: '虚拟现实 交互疗法'
				}
			]
		};
	}
};
</script>

<style lang="less" scoped>
.icon {
	font-style: inherit;
	position: relative;
}
.icon::after {
	content: '®';
	// position: absolute;
	font-size: 12px;
	display: inline-block;
	top: 0;
	line-height: 1;
	right: 0;
	transform: translateY(-8px);
}
.icon2 {
	font-style: inherit;
	position: relative;
	display: inline-block;
}
.icon2::after {
	content: 'TM';
	display: inline-block;
	// position: absolute;
	font-size: 12px;
	transform: scale(0.7) translateY(-8px);
	top: 0;
	line-height: 1;
	right: 0;
}
.banner {
	width: 100%;
	transition: all 0.2s;
}

.banner_small {
	display: none;
}

.container {
	padding-top: 86px;

	.cloudService {
		p {
			font-size: 16px;
			color: #8e8e8e;
			line-height: 36px;
			text-align: center;
			margin-top: 47px;
		}

		.box {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 109px 0 118px;

			img {
				width: 74px;
				margin-bottom: 42px;
			}

			div {
				min-width: 80px;
				text-align: center;
			}

			h5 {
				font-size: 20px;
				font-weight: 400;
				color: #262626;
				line-height: 28px;
				text-align: center;
			}
		}
	}
}

.partner {
	width: 100% !important;
	background: #f2f6f9;
	overflow: hidden;

	.box {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		margin: 87px 0 130px;

		img {
			width: 238px;
			height: 94px;
			background: #ffffff;
			border-radius: 8px;
			margin-bottom: 14px;
		}

		span {
			width: 238px;
			height: 0;
		}
	}
}

.database {
	p {
		width: 90%;
		font-size: 16px;
		color: #8e8e8e;
		line-height: 36px;
		text-align: center;
		margin: 47px auto 40px;
	}

	.btn {
		display: block;
		text-decoration: inherit;
		width: 202px;
		height: 50px;
		background: #16b7f3;
		border-radius: 2px;
		font-size: 16px;
		font-weight: 400;
		color: #ffffff;
		line-height: 50px;
		text-align: center;
		margin: 0 auto;

		img {
			width: 20px;
			padding-left: 13px;
		}
	}

	.btn2 {
		display: none;
	}

	.box {
		display: flex;
		justify-content: space-between;
		margin: 65px 0 58px;

		div {
			width: 400px;
			padding: 35px 0;
			background: #f8f9fd;
			border-radius: 6px;
			text-align: center;

			&:hover {
				box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
				transform: translate3d(0, -2px, 0);
			}

			img {
				width: 140px;
				margin-bottom: 32px;
			}

			span {
				display: inherit;
				font-size: 20px;
				font-weight: 400;
				color: #343434;
				line-height: 30px;
			}
		}
	}
}

.newIntervention {
	background: url('~@/assets/bg_guanli_jiejue_fangan.jpg') no-repeat bottom;
	background-size: cover;
	.content {
		padding: 0;
	}
	.textarea {
		width: 80%;
		margin: 0 auto;
		text-align: center;
		padding: 85px 0 420px;
		h5 {
			margin: 0 auto;
		}
		p {
			margin: 60px auto 40px;
			width: 90%;
			line-height: 36px;
		}
	}
}
.moreBtn {
	display: block;
	text-decoration: inherit;
	width: 202px;
	height: 50px;
	background: #16b7f3;
	border-radius: 2px;
	font-size: 16px;
	font-weight: 400;
	color: #ffffff;
	line-height: 50px;
	text-align: center;
	margin: 0 auto;

	img {
		width: 20px;
		padding-left: 13px;
	}
}
.cloudPlatform {
	.content {
		padding: 110px 0 120px;
	}
	.moreBtn {
		margin: 30px 0 0;
	}
}
@media (max-width: 768px) {
	.banner {
		display: none;
	}

	.banner_small {
		display: block;
	}

	.container {
		width: 90%;
		margin: 0 auto;

		.cloudService p {
			text-align: justify;
		}

		.cloudService .box {
			flex-wrap: wrap;
			justify-content: space-around;
			margin: 110px 0 0px;

			div {
				margin: 0 25px 78px;
				width: 110px;
			}
		}
	}

	.partner .box {
		width: calc(100% - 60px);
		margin: 66px auto 60px;
		justify-content: space-between;

		img {
			width: 48%;
			height: auto;
			margin-bottom: 22px;
		}

		span {
			width: 44%;
		}
	}

	.database {
		p {
			width: 100%;
			text-align: justify;
		}

		.btn {
			display: none;
		}

		.btn2 {
			width: 400px;
			height: 88px;
			line-height: 88px;
			font-size: 28px;
			background: #16b7f3;
			border-radius: 2px;
			display: block !important;
			margin-bottom: 86px;

			img {
				width: 40px;
				padding-left: 20px;
			}
		}

		.box {
			display: flex;
			justify-content: space-between;
			margin: 65px 0 58px;

			div {
				flex: 1;
				margin: 0 10px;
				padding: 40px 0 46px;

				img {
					width: 142px;
					margin-bottom: 21px;
				}

				span {
					font-size: 28px;
					color: #343434;
					margin-top: 20px;

					b {
						font-size: 36px;
					}
				}

				span:last-child {
					font-size: 24px;
				}
			}
		}
	}
	.moreBtn {
		width: 400px;
		height: 88px;
		line-height: 88px;
		font-size: 28px;
		background: #16b7f3;
		border-radius: 2px;
		display: block !important;
		margin: 50px auto 86px;
		img {
			width: 40px;
			padding-left: 20px;
		}
	}
	.newIntervention {
		height: 1058px;
		background: url('~@/assets/1.jpg') no-repeat bottom;
		background-size: cover;

		.textarea {
			width: 90%;
			text-align: left;

			h5 {
				margin: 0 auto;
				font-weight: normal;
			}

			p {
				width: 100%;
				line-height: 36px;
			}
		}
	}

	.cloudPlatform {
		.textarea {
			width: 90%;
			text-align: left;

			h5 {
				margin: 0 auto;
				font-weight: normal;
			}

			p {
				width: 100%;
				margin: 60px auto 40px;
				line-height: 36px;
			}

			.moreBtn {
				margin: 0 auto;

				img {
					display: initial;
					margin: 0;
				}
			}
		}
	}
}
</style>
